'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M48 376l0 56 416 0 0-56c0-30.9-25.1-56-56-56l-24 0 0-24c0-30.9-25.1-56-56-56-15.6 0-29.6 6.3-39.8 16.6l-24.3 24.5-14.5-31.3c-11.4-24.7-36.4-41.8-65.4-41.8-39.8 0-72 32.2-72 72l0 37.2-19.2 3.9C67.2 326.3 48 348.9 48 376zM330.3 144c20.2 .3 39.5 4.5 57 12 44.5-37.4 102-60 164.7-60l24 0c0-16 0-32 0-48l-24 0c-87.4 0-166.3 36.9-221.7 96zm99.8 39.4c11.9 10.8 22.1 23.5 30.1 37.5 26-18.2 57.6-28.9 91.8-28.9l24 0c0-16 0-32 0-48l-24 0c-45.5 0-87.6 14.6-121.9 39.4z', 'M330.3 144C385.8 84.9 464.6 48 552 48l24 0 0-48-24 0c-113.6 0-214.7 53.9-279.1 137.4 5.7 3.5 11.1 7.4 16.3 11.6 12.4-3.3 25.4-5 38.8-5 .8 0 1.5 0 2.3 0zm168 109.7C514.2 245 532.5 240 552 240l24 0 0-48-24 0c-34.2 0-65.8 10.7-91.8 28.9 2.8 4.9 5.3 10 7.6 15.3 10.9 4.7 21.1 10.5 30.5 17.5zm-68.1-70.3C464.4 158.6 506.5 144 552 144l24 0 0-48-24 0c-62.7 0-120.2 22.6-164.7 60 15.8 6.7 30.3 16 42.8 27.4zM112 280c0-39.8 32.2-72 72-72 28.9 0 53.9 17.1 65.4 41.8l14.5 31.3 24.3-24.5c10.2-10.3 24.2-16.6 39.8-16.6 30.9 0 56 25.1 56 56l0 24 24 0c30.9 0 56 25.1 56 56l0 56-416 0 0-56c0-27.1 19.2-49.7 44.8-54.9l19.2-3.9 0-37.2zm72-120c-66.3 0-120 53.7-120 120-37.6 15.7-64 52.7-64 96l0 104 512 0 0-104c0-50-35.3-91.7-82.3-101.7-10-47-51.7-82.3-101.7-82.3-18.3 0-35.4 4.7-50.3 13-22-27.4-55.7-45-93.7-45z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;